<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'ldfForm',
    text: 'LDF Form No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/passcardLostDamageFaultyForm?carparkID=${dataItem.carparkID}&applicationID=${dataItem.applicationID}">${helper.plFormLDFNum(dataItem.applicationID, dataItem.carparkID)}</a>`;
    },
  },
  {
    key: 'data2',
    text: 'Type',
  },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem['_licenseID']}">${helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum'])}</a>`;
    },
    form_hide: true, 
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
    form_hide: true, 
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_zoneName',
    text: 'Zone',
  },
  {
    key: '_productName',
    text: 'Product Name',
  },
  {
    key: '_parkerInformation',
    text: 'Parker Information',
  },
  {
    key: '_passcardType',
    text: 'Passcard Type',
  },
  {
    key: '_passcard',
    text: 'Passcard',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_passcard'];
      return (dataItem || {}).sku;
    },
  },
  {
    key: 'billNo',
    text: 'Bill No.',
  },
  {
    key: 'status2',
    text: 'Status',
  },
  {
    key: 'createDate',
    text: 'Submission Date',
    table_custom: helper.tableCustomDatetime,
  },
  {
    key: 'date1',
    text: 'Date Completed',
    table_custom: helper.tableCustomDatetime,
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePasscardLostDamageFaulty",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Lost/Damage/Faulty' },
      ],

      PARAM,
      PARAM_MAP,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    if(!helper.hasEditPermission(this.permission)) {
      this.PARAM_MAP['test2'].table_hide = true;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }

      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.loadPaymentMethod();
  },
  methods: {
    loadPaymentMethod() {
      let feedbackItem = 'payment method';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/paymethods/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pagePaymentMethod = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.pagePaymentMethod = JSON.parse(`[{"id":0,"name":"Giro","key":"Giro"},{"id":1,"name":"Cheque","key":"Cheque"},{"id":2,"name":"Cash","key":"Cash"},{"id":3,"name":"Online","key":"Online"}]`);
          this.loadCarpark();
          // this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // let selection = this.pageCarpark;
          // if(!helper.checkRoleIsParker()) {
          //   selection = [].concat({name: 'All Car Parks'}, selection);
          // }
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(selection, this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park application data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/request?type1=passcardLostDamageFaulty',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          let selection = this.pageCarpark;
          if(!helper.checkRoleIsParker()) {
            selection = [].concat({name: 'All Car Parks'}, selection);
          }
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(selection, this.$route.query.carparkID);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No passcard available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);
          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadPasscard();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/passcard/';

      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadPasscardLostDamageFaultyApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardLostDamageFaultyApplication() {
      let feedbackItem = 'passcard lost/damage/faulty application';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/requestgroup/?type1=passcardLostDamageFaulty';
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      if(this.$refs['licenseFilter'].filterValue) {
        url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      } else if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          // if(this.$refs['carparkFilter'].filterValue) {
          //   response.data = response.data.filter(k => helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue))
          // }
          // if(this.$refs['licenseFilter'].filterValue) {
          //   response.data = response.data.filter(k => helper.compareID(k.licenseID, this.$refs['licenseFilter'].filterValue))
          // }
          if(response.data && response.data.length > 0) {
            response.data.sort((a, b) => b.createDate - a.createDate);
            this.$refs['pageFeedback'].setFeedbackMessage();
            // this.pagePasscardReturn = response.data;
            // this.loadLease();
            this.pageLease = response.data;
            this.pageLease.forEach(k => {
              if(k['data5']) {
                k['_paymentMethod'] = (this.pagePaymentMethod.find(j => helper.compareID(j.id, k['data5'])) || {}).name
              }
            });
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      this.pageLease.forEach(k => {
        k['_license'] = this.$refs['licenseFilter'].filterData.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseID'] = k['_license']['id'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];

        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']) || {};
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']) || {};
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']) || {};
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']) || {};
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;

        if(k['passcardID']) {
          k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
          k['_passcardType'] = (this.pagePasstype.find(j => helper.compareID(j.id, k['_passcard']['passtypeID'])) || {}).name;
        }
      });
      
      this.$refs['pageTable'].setTableData(this.pageLease, this.$refs['pageTable'].getCurrentPage());
    },
    loadSeason() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let license = this.$refs['licenseFilter'].filterData.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      
      let url = helper.SERVER_URL + '/api2';
      if(license && license['_customer']) {
        url += '/customer/' + license['_customer']['id']
      }
      url += '/parker';

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onTablePageChange() {
      this.loadPasscardLostDamageFaultyApplication();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadPasscardLostDamageFaultyApplication();
    },
    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadPasscardLostDamageFaultyApplication();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscardLostDamageFaulty.vue